import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import styles from "./styles.css"

import IconChecked from "../../assets/svg/icon-checked.svg"

const InputCheckbox = ({
  id,
  name,
  label,
  onChange,
  value,
  checked,
  customLabel,
  className
}) => {
  const labelClass = classnames(styles.label, customLabel)
  return (
    <div className={classnames(styles.inputContainer, className)}>
      <input
        id={`${id}_${label}`}
        type="checkbox"
        name={name}
        onChange={onChange}
        checked={checked}
        className={styles.input}
        value={value}
      />
      <span className={styles.checkmark}>
        {checked && (
          <div className={styles.containerIcon}>
            <img src={IconChecked} />
          </div>
        )}
      </span>
      <label className={labelClass}>{label}</label>
    </div>
  )
}

InputCheckbox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  customLabel: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string
}

export default InputCheckbox



// WEBPACK FOOTER //
// ./src/components/InputCheckbox/index.js